// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComplexTable {
  --ct-header-height: 3.75rem;
  --ct-row-height: 3.75rem;
  --ct-border-color: rgba(0, 0, 0, 0.15);
  position: relative;
  height: 100%;
  border: 1px solid var(--ct-border-color);
  border-radius: var(--bs-border-radius);
  overflow: hidden;
}
.ComplexTable .ComplexTable-Container {
  position: relative;
  height: 100%;
  overflow: hidden auto;
  outline: none;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Row {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-width: 0;
  height: var(--ct-row-height);
  align-content: center;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Row .Grid-Cell.ComplexTable-Cell {
  display: flex;
  align-items: center;
  justify-content: start;
  height: var(--ct-row-height);
}
.ComplexTable .ComplexTable-Container .ComplexTable-Row .Grid-Cell.ComplexTable-Cell.Grid-Row-End {
  border-right: 1px solid var(--ct-border-color);
}
.ComplexTable .ComplexTable-Container .ComplexTable-Row .Grid-Cell:not(:first-child):not(.Grid-Row-Start) {
  border-left: none;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Header {
  position: sticky;
  top: 0;
  height: var(--ct-row-height);
  z-index: 100;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Header:after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1rem;
  border-bottom: 1px solid var(--ct-border-color);
  box-shadow: 0 0.25rem 0.5rem var(--ct-border-color);
}
.ComplexTable .ComplexTable-Container .ComplexTable-Header .ComplexTable-Row {
  z-index: 2;
  width: 100%;
  height: var(--ct-row-height);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Header .ComplexTable-Row .ComplexTable-Cell.ComplexTable-Cell {
  background-color: var(--bs-secondary-subtle);
  font-weight: 800;
  text-transform: uppercase;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Header .ComplexTable-Row .ComplexTable-Cell .ComplexTable-Sortable {
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  font-weight: inherit;
  text-align: inherit;
  font-weight: inherit;
  text-transform: inherit;
  gap: 0.5rem;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Body {
  flex-grow: 1;
  min-height: var(--ct-row-height);
}
.ComplexTable .ComplexTable-Container .ComplexTable-Body .ComplexTable-Row .Grid {
  border: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Body .ComplexTable-Row .Grid .ComplexTable-Cell.ComplexTable-Cell {
  min-height: var(--ct-row-height);
  font-weight: 700;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Body .ComplexTable-Row .Grid .ComplexTable-Cell.ComplexTable-Empty {
  text-align: center;
  justify-content: center;
  font-size: 1.25rem;
  opacity: 0.5;
  font-weight: 500;
}
.ComplexTable .ComplexTable-Container .ComplexTable-Body .ComplexTable-Row .Grid:not(:first-child):after {
  content: "";
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  border-top: 1px solid var(--ct-border-color);
}
.ComplexTable .ComplexTable-Container .ComplexTable-Body .ComplexTable-Row .Grid:hover:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  border: 3px solid var(--bs-secondary) !important;
  border-radius: var(--bs-border-radius) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ComplexTable/styles.scss"],"names":[],"mappings":"AAIA;EACE,2BAAA;EACA,wBAAA;EACA,sCAAA;EAEA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,gBAAA;AAJF;AAKE;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;AAHJ;AAII;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;EACA,qBAAA;AAFN;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;AAFV;AAGU;EACE,8CAAA;AADZ;AAIQ;EACE,iBAAA;AAFV;AAMI;EACE,gBAAA;EACA,MAAA;EACA,4BAAA;EACA,YAAA;AAJN;AAKM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EACA,mDAAA;AAHR;AAKM;EACE,UAAA;EACA,WAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;AAHR;AAKU;EACE,4CAAA;EACA,gBAAA;EACA,yBAAA;AAHZ;AAKU;EACE,SAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;AAHZ;AAQI;EACE,YAAA;EACA,gCAAA;AANN;AAQQ;EACE,SAAA;EACA,yBAAA;EACA,0BAAA;AANV;AAQY;EACE,gCAAA;EACA,gBAAA;AANd;AAQY;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AANd;AAUY;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,4CAAA;AARd;AAWU;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,gDAAA;EACA,iDAAA;AATZ","sourcesContent":["$header-height: 3.75rem;\n$row-height: 3.75rem;\n$border-color: rgba(0, 0, 0, 0.15);\n\n.ComplexTable {\n  --ct-header-height: #{$header-height};\n  --ct-row-height: #{$row-height};\n  --ct-border-color: #{$border-color};\n\n  position: relative;\n  height: 100%;\n  border: 1px solid var(--ct-border-color);\n  border-radius: var(--bs-border-radius);\n  overflow: hidden;\n  .ComplexTable-Container {\n    position: relative;\n    height: 100%;\n    overflow: hidden auto;\n    outline: none;\n    .ComplexTable-Row {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      border-width: 0;\n      height: var(--ct-row-height);\n      align-content: center;\n      .Grid-Cell {\n        &.ComplexTable-Cell {\n          display: flex;\n          align-items: center;\n          justify-content: start;\n          height: var(--ct-row-height);\n          &.Grid-Row-End {\n            border-right: 1px solid var(--ct-border-color);\n          }\n        }\n        &:not(:first-child):not(.Grid-Row-Start) {\n          border-left: none;\n        }\n      }\n    }\n    .ComplexTable-Header {\n      position: sticky;\n      top: 0;\n      height: var(--ct-row-height);\n      z-index: 100;\n      &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 1rem;\n        border-bottom: 1px solid var(--ct-border-color);\n        box-shadow: 0 0.25rem 0.5rem var(--ct-border-color);\n      }\n      .ComplexTable-Row {\n        z-index: 2;\n        width: 100%;\n        height: var(--ct-row-height);\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        .ComplexTable-Cell {\n          &.ComplexTable-Cell {\n            background-color: var(--bs-secondary-subtle);\n            font-weight: 800;\n            text-transform: uppercase;\n          }\n          .ComplexTable-Sortable {\n            margin: 0;\n            padding: 0;\n            border: 0;\n            width: 100%;\n            height: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: transparent;\n            font-weight: inherit;\n            text-align: inherit;\n            font-weight: inherit;\n            text-transform: inherit;\n            gap: 0.5rem;\n          }\n        }\n      }\n    }\n    .ComplexTable-Body {\n      flex-grow: 1;\n      min-height: var(--ct-row-height);\n      .ComplexTable-Row {\n        .Grid {\n          border: 0;\n          border-top-left-radius: 0;\n          border-top-right-radius: 0;\n          .ComplexTable-Cell {\n            &.ComplexTable-Cell {\n              min-height: var(--ct-row-height);\n              font-weight: 700;\n            }\n            &.ComplexTable-Empty {\n              text-align: center;\n              justify-content: center;\n              font-size: 1.25rem;\n              opacity: 0.5;\n              font-weight: 500;\n            }\n          }\n          &:not(:first-child) {\n            &:after {\n              content: '';\n              position: absolute;\n              width: 100%;\n              top: 0;\n              left: 0;\n              border-top: 1px solid var(--ct-border-color);\n            }\n          }\n          &:hover:after {\n            content: '';\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            z-index: 1;\n            pointer-events: none;\n            border: 3px solid var(--bs-secondary) !important;\n            border-radius: var(--bs-border-radius) !important;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
